import { breakpoints } from 'app/constants';
import {
  SITE_LOCAL_SETTINGS_KEY,
  RESIZABLE_BLOCK,
  defaultSiteSettings,
} from './constants';

export type ResizableBlockKey = keyof typeof RESIZABLE_BLOCK;

export const getMinWidth = (key: ResizableBlockKey) =>
  RESIZABLE_BLOCK[key].minWidth;
export const getMaxWidth = (key: ResizableBlockKey) =>
  RESIZABLE_BLOCK[key].maxWidth;
export const getMinExpandedWidth = (key: ResizableBlockKey) =>
  RESIZABLE_BLOCK[key].minExpandedWidth;

export const getSiteLocalSettings = () =>
  JSON.parse(
    localStorage.getItem(SITE_LOCAL_SETTINGS_KEY) ||
      JSON.stringify(defaultSiteSettings)
  );

export const getWidth = (key: ResizableBlockKey) =>
  getSiteLocalSettings()[key]?.width || getMaxWidth(key);

export const isMaxWidth = (key: ResizableBlockKey) =>
  getWidth(key) === getMaxWidth(key);

export const isMinWidth = (key: ResizableBlockKey) =>
  getWidth(key) === getMinWidth(key);

export const showFullSideBarHeader = (key: ResizableBlockKey, width: string) =>
  parseInt(width, 10) >= parseInt(getMinExpandedWidth(key), 10);

type UpdateSiteSettingsKey = ResizableBlockKey | 'songs' | string;

const getSiteSettings = () => ({
  ...defaultSiteSettings,
  ...getSiteLocalSettings(),
});

export const updateSiteSettings = (key: UpdateSiteSettingsKey, newSettings) => {
  const oldSettings = getSiteSettings();

  localStorage.setItem(
    SITE_LOCAL_SETTINGS_KEY,
    JSON.stringify({
      ...oldSettings,
      [key]: {
        ...oldSettings[key],
        ...newSettings,
      },
    })
  );
};

export const removeSiteSetting = (key: UpdateSiteSettingsKey) => {
  const { [key]: _, ...settings } = getSiteSettings();
  localStorage.setItem(SITE_LOCAL_SETTINGS_KEY, JSON.stringify(settings));
};

export const getCursor = (key: ResizableBlockKey, siderBarWidth: string) => {
  return siderBarWidth === getMaxWidth(key)
    ? 'w-resize'
    : siderBarWidth === getMinWidth(key)
    ? 'e-resize'
    : 'ew-resize';
};

export const getNewWidth = (width: string, dx: number) => {
  const newNumericWidth = parseInt(width, 10) - dx;
  const minExpandedWidth = parseInt(getMinExpandedWidth('sidebar'), 10);

  if (dx < 0) {
    return `${Math.max(newNumericWidth, minExpandedWidth)}px`;
  }

  if (dx > 0 && newNumericWidth < minExpandedWidth) {
    return getMinWidth('sidebar');
  }

  return `${newNumericWidth}px`;
};

export const isSmallScreen = (width: number) =>
  width < breakpoints.mobileScreen;
